import React, {useState} from "react";

export const NavIconWrapper = ({collapsed, active, style, children}) => {
    const [isHovered, setHovered] = useState(false);

    const getColor = () => {
        if (collapsed && !active) {
            return isHovered ? '#FAFAFA' : '#93939E';
        }
        return active ? '#FAFAFA' : 'inherit';
    }

    return (
        <div className={`nav-btn-icon-wrapper ${collapsed ? 'collapsed' : ''}`}
             style={style ? style : {color: getColor()}}
             onMouseEnter={() => setHovered(true)}
             onMouseLeave={() => setHovered(false)}>
            {children}
        </div>
    );
}